import { render } from "./FormRole.vue?vue&type=template&id=d005c768"
import script from "./FormRole.vue?vue&type=script&lang=js"
export * from "./FormRole.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__